/**
 * Query params for lead quiz relations.
 * Note: relation indexes intentionally follow backend expectation.
 */
export const LEAD_QUIZ_RELATIONS = {
  'relations[0]': 'author',
  'relations[2]': 'status',
};

export const buildLeadQuizRelationParams = () => ({ ...LEAD_QUIZ_RELATIONS });
